import { PlanEntryActiveListItem } from "../../../../common/services/plan-entry/active-list/plan-entry-active-list";
import RouteActiveListingSortKey from "./types/route-active-listing-sort-key";

const sortByDriverNameAsc = (
  listingItems: PlanEntryActiveListItem[],
): PlanEntryActiveListItem[] => {
  return listingItems.sort((itemA, itemB) =>
    itemA.driverName >= itemB.driverName ? 1 : -1,
  );
};

const sortByDriverNameDesc = (
  listingItems: PlanEntryActiveListItem[],
): PlanEntryActiveListItem[] => {
  return listingItems.sort((itemA, itemB) =>
    itemB.driverName >= itemA.driverName ? 1 : -1,
  );
};

const sortByRouteIdAsc = (
  listingItems: PlanEntryActiveListItem[],
): PlanEntryActiveListItem[] => {
  return listingItems.sort((itemA, itemB) => itemA.humanId - itemB.humanId);
};

const sortByRouteIdDesc = (
  listingItems: PlanEntryActiveListItem[],
): PlanEntryActiveListItem[] => {
  return listingItems.sort((itemA, itemB) => itemB.humanId - itemA.humanId);
};

const sortByTaxiCorporationAsc = (
  listingItems: PlanEntryActiveListItem[],
): PlanEntryActiveListItem[] => {
  return listingItems.sort((itemA, itemB) =>
    itemA.taxiCorporationName >= itemB.taxiCorporationName ? 1 : -1,
  );
};

const sortByTaxiCorporationDesc = (
  listingItems: PlanEntryActiveListItem[],
): PlanEntryActiveListItem[] => {
  return listingItems.sort((itemA, itemB) =>
    itemB.driverName >= itemA.driverName ? 1 : -1,
  );
};

const sortListingItems = (
  listingItems: PlanEntryActiveListItem[],
  sortKey: RouteActiveListingSortKey | null,
): PlanEntryActiveListItem[] => {
  switch (sortKey) {
    case RouteActiveListingSortKey.DRIVER_NAME_ASC:
      return sortByDriverNameAsc(listingItems);
    case RouteActiveListingSortKey.DRIVER_NAME_DESC:
      return sortByDriverNameDesc(listingItems);
    case RouteActiveListingSortKey.HUMAN_ID_ASC:
      return sortByRouteIdAsc(listingItems);
    case RouteActiveListingSortKey.HUMAN_ID_DESC:
      return sortByRouteIdDesc(listingItems);
    case RouteActiveListingSortKey.TAXI_CORPORATION_ASC:
      return sortByTaxiCorporationAsc(listingItems);
    case RouteActiveListingSortKey.TAXI_CORPORATION_DESC:
      return sortByTaxiCorporationDesc(listingItems);
    default:
      return listingItems;
  }
};

const routeActiveListingSortingService = {
  sortListingItems,
};

export default routeActiveListingSortingService;
